import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Erase = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 26H15.657L26.828 14.829C27.572 14.084 28 13.054 28 12C28 10.946 27.573 9.916 26.828 9.171L22.828 5.171C22.083 4.426 21.052 4 20 4C18.948 4 17.916 4.427 17.172 5.171L5.17198 17.171C4.42698 17.916 4.00098 18.947 4.00098 19.999C4.00098 21.051 4.42798 22.083 5.17198 22.827L9.17198 26.827C9.91698 27.571 10.948 27.999 12.001 27.999H27.001C27.553 27.999 28.001 27.551 28.001 26.999C28.001 26.447 27.553 25.999 27.001 25.999L27 26ZM18.586 6.586C18.958 6.214 19.474 6 20 6C20.526 6 21.042 6.213 21.414 6.586L25.414 10.586C25.786 10.958 26 11.474 26 12C26 12.526 25.787 13.042 25.414 13.414L20.121 18.707L13.293 11.879L18.586 6.586V6.586ZM6.58598 21.414C6.21398 21.042 5.99998 20.526 5.99998 20C5.99998 19.474 6.21298 18.958 6.58598 18.586L11.879 13.293L18.707 20.121L13.414 25.414C13.042 25.786 12.526 26 12 26C11.474 26 10.958 25.787 10.586 25.414L6.58598 21.414V21.414Z" />
	</svg>
);

export default Erase;
